import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import WrapperContainer from "../components/WrapperContainer/WrapperContainer.jsx";

import SvgIcon from "../components/Icon/SvgIcon.jsx";
import ShimmerLine from "../components/Shimmer/ShimmerLine.jsx";

import Button from "../components/Button/Button.jsx";
import { APP_ROUTES } from "../router";

import actions from "../store/actions.js";
import { apiFetchCustomerInitials } from "../api/methods/customer.js";

import getClassNames from "../utils/helpers/getClassNames";

const OPTIONS = [
  { id: 0, label: "individual", value: "individual" },
  { id: 1, label: "legal", value: "legal" },
];

const ChoiceTypeConnection = () => {
  const dispatch = useDispatch();
  const history = useNavigate();

  const { mobileConnectionInfo } = useSelector(state => state);
  const [activeOption, setActiveOption] = useState("");

  const [userId, setUserId] = useState("");
  const [title, setTitle] = useState("");

  useEffect(() => {
    (async () => {
      let title = "Подключить Уфанет";
      localStorage.removeItem("partnerProgram");

      try {
        const regExp = /.+start\/(\w+)$/g;
        const hasUserId = regExp.test(window.location.href);
        const urlSegment = hasUserId ? window.location.href.replace(regExp, "$1") : "-";

        if (hasUserId) title = await apiFetchCustomerInitials(urlSegment);

        setUserId(urlSegment);
        setTitle(title);
      } catch {
        setTitle(title);
      }
    })();
  }, []);

  const saveUserInfoToLocaleStorage = () => {
    dispatch(
      actions.mobileConnection.changeConnectionData({
        ...mobileConnectionInfo,
        /**
         * Уникальный идентификатор пользователя (сотрудник, агент).
         * Используется для реферальной системы
         */
        refUserId: userId,
        initialUrl: window.location.href,
      })
    );
  };

  const redirectToNextStep = () => {
    saveUserInfoToLocaleStorage();

    if (activeOption === "individual") {
      history(APP_ROUTES.MOBILE_CONNECTION.PERSONAL_DATA_ROUTE);
    } else {
      history(APP_ROUTES.MOBILE_CONNECTION.PERSONAL_DATA_BUSINESS_ROUTE);
    }
  };

  /**
   * @param {Object} option
   * @return {String}
   */
  const getClassNameList = option => {
    return getClassNames([
      "selectable-container",
      option.label === activeOption && "selectable-container--active",
      Boolean(userId.length > 1) && "selectable-container--stretch",
    ]);
  };

  return (
    <div>
      <WrapperContainer gap="24" title="sm">
        {title || <ShimmerLine />}
      </WrapperContainer>

      <WrapperContainer gap="24" text="lg">
        <div className="selectable-wrapper-container">
          {OPTIONS.map(option => (
            <div
              className={getClassNameList(option)}
              key={option.id}
              onClick={() => setActiveOption(option.value)}
            >
              {option.id === 0 && (
                <>
                  <SvgIcon hasBg name="home" color="#2A2E35" bg="#F4F4F4" />
                  <WrapperContainer text="lg" className="selectable-container__item-title">
                    Для дома
                  </WrapperContainer>
                  {Boolean(userId.length > 1) && (
                    <WrapperContainer text="lg" className="selectable-container__item-desc">
                      Начислим баллы в размере вашей первой абонентской платы. Ими можно оплачивать
                      услуги Уфанет. 1 бонус = 1 руб.
                    </WrapperContainer>
                  )}
                </>
              )}
              {option.id === 1 && (
                <>
                  <SvgIcon hasBg name="business" color="#2A2E35" bg="#F4F4F4" />
                  <WrapperContainer text="lg" className="selectable-container__item-title">
                    Для бизнеса
                  </WrapperContainer>
                  {Boolean(userId.length > 1) && (
                    <WrapperContainer text="lg" className="selectable-container__item-desc">
                      Получите скидку 50% на абонентскую плату в первый месяц
                    </WrapperContainer>
                  )}
                </>
              )}
            </div>
          ))}
        </div>
      </WrapperContainer>

      <Button isStretch color="primary" onClick={redirectToNextStep} disabled={!activeOption}>
        Далее
      </Button>
    </div>
  );
};

export default ChoiceTypeConnection;
